import dynamic from 'next/dynamic';
import React from 'react'
import styles from './reviewsView.module.scss';

import { cx } from '@emotion/css';

const DynamicReviews = dynamic(() => import('components/TrustPilot'), {
  ssr: true,
});

export const AboutUsReview = () => {
  return (
    <div className={cx(styles.sec, styles.root, styles.root_home)}>
      <DynamicReviews styles={styles} />
    </div>
  )
}